import createAxiosInstance from './Axios';

export const callCreateTicket = async (data, baseURL) => {
  const axiosInstance = createAxiosInstance(baseURL);
  return axiosInstance({
    url: `/form/create${data.path}`,
    method: 'post',
    data: data.form,
  });
};
